import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { TextM } from '../typography/typography';
import { useSelect } from './select';
import styles from './styles.module.scss';
export var SelectValue = function (_a) {
    var children = _a.children, placeholder = _a.placeholder;
    var setHasValue = useSelect().setHasValue;
    useEffect(function () {
        setHasValue(!!children);
    }, [children, setHasValue]);
    if (!children) {
        return _jsx(TextM, { className: styles.placeholder, children: placeholder });
    }
    if (typeof children === 'string') {
        return _jsx(TextM, { children: children });
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: children });
};
